module.exports = __webpack_public_path__ + "img/郑州仓库.bddfe7d3.jpg";